import * as React from 'react';

function SvgReload(props) {
  return (
    <svg viewBox="0 0 15 14" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M13.705 2.27l-.882.69A6.547 6.547 0 007.655.437a6.558 6.558 0 00-6.561 6.554A6.561 6.561 0 0013.82 9.248a.125.125 0 00-.076-.16l-.886-.305a.125.125 0 00-.158.075 5.346 5.346 0 01-1.244 1.942 5.34 5.34 0 01-3.798 1.575A5.334 5.334 0 013.859 10.8a5.346 5.346 0 01-1.573-3.802 5.347 5.347 0 011.573-3.801 5.34 5.34 0 013.798-1.575 5.334 5.334 0 013.8 1.575c.154.155.3.319.434.49l-.941.735a.125.125 0 00.047.22l2.744.672a.125.125 0 00.154-.12l.013-2.827a.126.126 0 00-.203-.097z" />
    </svg>
  );
}

export default SvgReload;
